/**
 * FINTWIN legal documents and signup-source codes - the single place that
 * names them, so every consent checkbox and the Documents tab link the same
 * file.
 *
 * The PDFs are brand assets: `apps/common/resources/fintwinpay-com/docs/*.pdf`
 * is copied into `public/` by `Dockerfile.brand`, so `/docs/*` resolves only in
 * a brand image (it 404s under `yarn dev`). The website pages live on the
 * marketing site, outside this repo.
 */
export const FINTWIN_DOCS = {
  websiteTerms: 'https://fintwinpay.com/pages/terms-of-use.html',
  privacyPolicy: 'https://fintwinpay.com/pages/privacy-policy.html',
  clientTerms: '/docs/terms.pdf',
  businessTerms: '/docs/terms-business.pdf',
  feeSchedule: '/docs/fees.pdf',
  riskDisclosure: '/docs/risk-disclosure.pdf',
} as const

/**
 * "How did you hear about FINTWIN Pay?" answer codes. Sent as `source_code` on
 * registration. `advertisement` and `introducer` are listed on purpose: the
 * reverse-solicitation control has to be able to fail.
 */
export const SIGNUP_SOURCE_CODES = [
  'search',
  'direct',
  'recommendation',
  'adviser',
  'introducer',
  'registry',
  'event',
  'social',
  'advertisement',
  'other',
] as const

export type SignupSourceCode = typeof SIGNUP_SOURCE_CODES[number]

/** Sources that require a free-text detail (partner name / "please specify"). */
export const SIGNUP_SOURCES_WITH_DETAIL: readonly SignupSourceCode[] = [
  'introducer',
  'other',
]
